// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__yAYx6","logoImg":"Header_logoImg__LSbDK","logoName":"Header_logoName__UBEci","cartInfo":"Header_cartInfo__AKtG6","price":"Header_price__YIYZl"};